import { z } from "zod";

import { PluginCurrencySchema } from "./currencyFormat";
import { PluginDownSamplingSchema } from "./downSampling";
import { PluginShopCurrencySchema } from "./shopCurrency";

export const PluginOptionsSchema_2023_08_20 = z.object({
  currencyFormat: PluginCurrencySchema.nullish(),
  shopCurrency: PluginShopCurrencySchema.nullish(),
  currencyFn: z.string().nullish(),
  additionalPriceQuerySelectors: z.optional(z.string().array()),
  additionalComparePriceQuerySelectors: z.optional(z.string().array()),
  additionalVolumeDiscountQuerySelectors: z.optional(z.string().array()),
  additionalInstallmentPriceQuerySelectors: z.optional(z.string().array()),
  additionalCartDiscountMessageSelectors: z.optional(z.string().array()),
  additionalSavingsPriceQuerySelectors: z.optional(z.string().array()),
  additionalSavingsPercentageQuerySelectors: z.optional(z.string().array()),
  additionalCartSavingsSelectors: z.optional(z.string().array()),
  additionalCartOriginalTotalSelectors: z.optional(z.string().array()),
  addIgDiscountToHrefQuerySelectors: z.optional(z.string().array()),
  shadowElementSelectors: z.optional(z.string().array()),
  interceptAtcXhr: z.boolean().nullish(),
  shouldRedirect: z.boolean().nullish(),
  lazyCartUpdate: z.boolean().nullish(),
  shouldUseProductMeta: z.boolean().nullish(),
  shouldHideShippingSubtext: z.boolean().nullish(),
  isHeadlessStorefront: z.boolean().nullish(),
  updateVariantsInATCForm: z.boolean().nullish(),
  useBeacon: z.boolean().nullish(),
  addTestGroupId: z.boolean().nullish(),
  shouldDuplicateProducts: z.boolean().nullish(),
  enableAi: z.boolean().nullish(),
  locale: z.string().default("en-US"),
  cousinsMaxLevelsUp: z.number().nullish(),
  metricsSampleRate: z.number().nullish(),
  downSampling: PluginDownSamplingSchema.nullish(),
  domain: z.string().nullish(),
  eagerUpdateDom: z.boolean().nullish(),
  shopifyFunctionsEnabled: z.boolean().nullish(),
  shopifyFunctionsForPricingEnabled: z.boolean().nullish(),
  priceSplittingEnabled: z.boolean().nullish(),
  shouldModifyVdRequests: z.boolean().nullish(),
  discountTitle: z.string().nullish(),
  useBrowserLocale: z.boolean().nullish(),
  usePriceProperty: z.boolean().nullish(),
  css: z.string().nullish(),
});
export type PluginOptionsType_2023_08_20 = z.infer<
  typeof PluginOptionsSchema_2023_08_20
>;
